export class StateBased {
  constructor({
    stateBasedID = 0,
    state = null,
    answeringPoint = null,
    inboundID = 0
  } = {}) {
    this.stateBasedID = stateBasedID;
    this.state = state;
    this.answeringPoint = answeringPoint;
    this.inboundID = inboundID;
  }
}

export function CreateNewStateBased(data) {
  return Object.freeze(new StateBased(data));
}
